<template>
  <v-sheet class="pa-1" :color="'grey-lighten-4'" height="100%" width="100%" :rounded="rounded">
    <v-sheet class="pa-1" :color="element_value ? 'green' : 'grey-lighten-2'" height="100%" width="100%" :rounded="rounded">
      <v-btn :block="block" v-on:click="toggle_value()" height="100%" flat :rounded="rounded" :color="'grey-lighten-4'" style="position: relative;">
        <slot />
        <span v-if="label">{{ label }}</span>
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>

<script>
export default {
  name: "grdn-toggle",
  props: {
    modelValue: Boolean,
    rounded: {
      type: [String, Number, null],
      default: 0
    },
    label: {
      type: [String, null],
      default: null
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle_value: function () {
      this.element_value = !this.element_value
    }
  },
  computed: {
    element_value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
  }
}
</script>

<style scoped>

</style>
